import { debounceTime, filter, Observable, Subject } from 'rxjs';
import { Component, computed, effect, ElementRef, EventEmitter, HostListener, input, Input, model, OnChanges, OnInit, Output, signal, viewChild } from '@angular/core';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss']
})

export class SearchFieldComponent  {

  element = viewChild<ElementRef<HTMLInputElement>>('element');

  @Input() placeholder: string = '';

  resultList = input<string[]>()
  searching = input<boolean>()
  @Output() resultSelected = new EventEmitter();

  searchTerm = model<string>('')

  @Input() highlightSearchTerm = false;

  @Input() size: 'sml' | 'big' | 'md' = 'md'
  @Input() disable = false;

  hideItemsFocusState = signal(false)
  itemSelected = signal(false)

  itemsToShow = computed( () => {
    if (this.hideItemsFocusState() || this.itemSelected()){
      return []
    }
    const word = this.searchTerm()
    return this.resultList()?.filter( item => item.includes(word) ) ?? []
  })

  onLoadingFinishEffect = effect( () => {
    const loading = this.searching()
    const resultList = (this.resultList()?.length ?? 0) > 0

    if (!loading && resultList) {
      this.element()?.nativeElement.focus()
    }
  })


  selectItem(itemSelected: string){
    this.searchTerm.set(itemSelected);
    this.resultSelected.emit(itemSelected)
    this.itemSelected.set(true)
  }

  onFocus(focus: boolean) {
    // precisa esperar para apagar lista
    // ou as opçoes vao sumir antes do user conseguir
    // clicar no item
    setTimeout( () => {
      if(focus){
        this.hideItemsFocusState.set(false)
        //  this.selectedElement = event.target;
        // this.refreshItems()
      } else {
        this.hideItemsFocusState.set(true)
        this.itemSelected.set(false)
        //  this.selectedElement = null;
        // this.listItems = []
      }
    }, 100)
  }

}
